import React from 'react';
import { Badge } from '../../../components/ui/badge';

export const WEEKDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const STATUS_STYLES = {
  active: 'bg-green-100 text-green-800',
  paused: 'bg-yellow-100 text-yellow-800',
  cancelled: 'bg-gray-100 text-gray-600',
  pending: 'bg-amber-100 text-amber-800',
  needs_attention: 'bg-red-100 text-red-800',
  placed: 'bg-green-100 text-green-800',
  skipped: 'bg-gray-100 text-gray-600',
  auto_skipped: 'bg-gray-100 text-gray-600',
  not_deliverable: 'bg-red-100 text-red-700',
  scheduled: 'bg-blue-50 text-blue-700',
};

export const STATUS_LABELS = {
  needs_attention: 'Needs attention',
  auto_skipped: 'Auto-skipped',
  not_deliverable: 'Not deliverable',
};

export const StatusBadge = ({ status, testId }) => (
  <Badge className={STATUS_STYLES[status] || 'bg-gray-100 text-gray-600'} data-testid={testId}>
    {STATUS_LABELS[status] || (status ? status.charAt(0).toUpperCase() + status.slice(1) : '')}
  </Badge>
);

export const itemsSummary = (items) =>
  (items || []).map((i) => `${i.quantity}× ${i.product_name}`).join(', ');

export const prettyDate = (dateStr) =>
  dateStr
    ? new Date(`${dateStr}T12:00:00`).toLocaleDateString('en-US', {
        weekday: 'short', month: 'short', day: 'numeric',
      })
    : '';

export const policyLabel = (template) =>
  template?.no_action_policy === 'auto_place'
    ? `If I don't act: place order${template.menu_change_policy === 'place_available' ? ' (available items only if menu changed)' : ' (skip if menu changed)'}`
    : "If I don't act: skip this date";
